import type { CmsApiPageId } from 'modules/cms/api/types/CmsApiTypedId';
import { FetchEndpoint } from 'utils/endpoint/FetchEndpoint';

import type { CmsApiReactionContext } from './types/CmsApiReactionContext';

type ApiResponse = CmsApiReactionContext;

function mapResponse(response: ApiResponse): CmsApiReactionContext {
  return response;
}

const endpoint = new FetchEndpoint({
  urlFactory: (pageId: CmsApiPageId) =>
    `/data/website/reactions/cms-pages/${pageId}`,
  mapResponse,
});

// Exports

export const useCmsApiFetchReaction = endpoint.createUseFetchHook();
